import { useApi } from "../hooks/useApi";
import { api } from "../lib/api";

export function SavedPage() {
  const session = useApi(api.session, []);
  const saved = useApi(api.saved, []);
  if (!session.loading && !session.data?.user) return <section className="page-slab narrow"><header className="page-head"><h1>Saved</h1></header><div className="state">Sign in to keep saved posts across devices.</div><a className="primary" href="/login">Sign in</a></section>;
  return <section className="page-slab"><header className="page-head"><h1>Saved</h1></header><div className="profile-grid">{saved.data?.map((post) => <a href={`/p/${post.id}`} key={post.id}>{post.media[0] ? <img src={post.media[0].url} alt="" /> : <span>{post.caption}</span>}</a>)}</div>{saved.data?.length === 0 && <div className="state">Saved posts will appear here.</div>}</section>;
}
